export default {
	title: 'motion_settings',
	components: [
		{ title: 'motion_configuration', component: 'motion_configuration_g4' },
		{ title: 'sensor_settings', component: 'motion_sensor_settings_g4' },
		{ title: 'presence_ui_settings', component: 'presence_ui_settings_g4' },
	],
};
